import {castDraft} from 'immer'

import type {KeyValue} from '@jetbrains/teamcity-ui/dist/utils'
import {createReducer, isAnyOf} from '@reduxjs/toolkit'
import * as Redux from 'redux'

import type {FileChange} from '../../../../services/rest'
import {restApi} from '../../../../services/rest'
import type {ChangeId} from '../../../../types'
import {toChangeId} from '../../../../types'

const changeFiles = Redux.combineReducers({
  changesFiles: createReducer<KeyValue<ChangeId, ReadonlyArray<FileChange>>>({}, builder => {
    builder.addMatcher(restApi.endpoints.getChangeFiles.matchFulfilled, (state, action) => {
      const files = action.payload?.file

      if (files == null) {
        return
      }

      state[action.meta.arg.originalArgs.changeId] = castDraft(files)
    })
    builder.addMatcher(
      isAnyOf(
        restApi.endpoints.getAllChanges.matchFulfilled,
        restApi.endpoints.getChangeLog.matchFulfilled,
      ),
      (state, action) => {
        const {changes} = action.payload.changes?.entities ?? {}

        if (changes == null) {
          return
        }

        for (const [changeId, change] of Object.entries(changes)) {
          if (change?.files?.file != null) {
            state[toChangeId(changeId)] = change.files.file
          }
        }
      },
    )
  }),
})

export default changeFiles
